import React from 'react';
import { connect } from 'react-redux';
import { MenuItemLink, getResources, Responsive } from 'react-admin';
import { withRouter } from 'react-router-dom';

import List from '@material-ui/core/List';
import ListSubheader from '@material-ui/core/ListSubheader';

import PeopleIcon from '@material-ui/icons/People';
import GroupAddIcon from '@material-ui/icons/GroupAdd';
import EmailIcon from '@material-ui/icons/Email';
import RepeatIcon from '@material-ui/icons/Repeat';
import HourglassEmptyIcon from '@material-ui/icons/HourglassEmpty';
import DashboardIcon from '@material-ui/icons/Dashboard';
import ListAltIcon from '@material-ui/icons/ListAlt';
import TrendingUpIcon from '@material-ui/icons/TrendingUp';
import LockOpenIcon from '@material-ui/icons/LockOpen';
import AccountTreeIcon from '@material-ui/icons/AccountTree';
import OpacityIcon from '@material-ui/icons/Opacity';
import ExtensionIcon from '@material-ui/icons/Extension';
import StarBorderIcon from '@material-ui/icons/StarBorder';
import HistoryIcon from '@material-ui/icons/History';
import GolfCourseIcon from '@material-ui/icons/GolfCourse';
import AssessmentIcon from '@material-ui/icons/Assessment';
import AdjustIcon from '@material-ui/icons/Adjust';
import { usePermissions } from 'react-admin';
import { ROLE_ADMIN, ROLE_LLM, ROLE_UACTIVITY,isInRole } from './authProvider';
import history from './history';

const MyMenu = ({ resources, onMenuClick, logout }) => {
		const { permissions } = usePermissions();
		const isAdmin = isInRole(ROLE_ADMIN, permissions);
		const isLLM = isInRole(ROLE_LLM, permissions);
		let isUA = isInRole(ROLE_UACTIVITY, permissions);

		if(isAdmin){
			isUA = false;
		}
		if(isUA){
			if(history.location.hash !== "#ScheduledTask/UserActivities"){
			history.replace({ pathname: '/he-auth-admin/', search: '', hash: '#ScheduledTask/UserActivities', state:{isActive: true}});
		}}

		return (<div>
			{(isUA) ?<MenuItemLink
				to ="/ScheduledTask/UserActivities" 
				key="HEXSelectorUserActivity"
				primaryText="Dashboard"
				leftIcon={<DashboardIcon />}
				onClick={onMenuClick}
			>
			</MenuItemLink>:<MenuItemLink
				to="/" 
				key="home"
				primaryText="Dashboard"
				leftIcon={<DashboardIcon />}
				onClick={onMenuClick}
			>
			</MenuItemLink>}
			{(isLLM || isAdmin) ?
			<List component="nav" subheader={<ListSubheader component="div">Common</ListSubheader>}>
				{(isLLM || isAdmin) ? <MenuItemLink key="users" to="/users" primaryText="Users" leftIcon={<GroupAddIcon />} onClick={onMenuClick} /> : null }
				{isAdmin ? <MenuItemLink key="roles" to="/roles" primaryText="Roles" leftIcon={<PeopleIcon />} onClick={onMenuClick} /> : null }
			</List>
			: null}
			{(isLLM || isAdmin) ?
			<List component="nav" subheader={<ListSubheader component="div">HEXSelector</ListSubheader>}>
				{(isLLM || isAdmin) ? <MenuItemLink key="HEXSelectorPending" to="/HEXSelector/PendingUsers" primaryText="Pending Requests" leftIcon={<HourglassEmptyIcon />} onClick={onMenuClick} /> : null}
				{isAdmin ? <MenuItemLink key="LocalLicenseManagers" to="/HEXSelector/LocalLicenseManagers" primaryText="Local License Managers" leftIcon={<EmailIcon />} onClick={onMenuClick} /> : null}
				{isAdmin ? <MenuItemLink key="hexSelectorUserReporting" to="/HEXSelector/Reporting" primaryText="Crash Reports" leftIcon={<RepeatIcon />} onClick={onMenuClick} /> : null}
				{isAdmin ? <MenuItemLink key="hexSelectorClientTelemetrics" to="/HEXSelector/Telemetrics" primaryText="Client Telemetrics" leftIcon={<AssessmentIcon />} onClick={onMenuClick} /> : null}
			</List>
			: null}
			{(isUA || isAdmin) ?
			<List  component="nav" subheader={<ListSubheader component="div">HEXSelector Statistics</ListSubheader>}>
				{(isUA || isAdmin) ?<MenuItemLink key="HEXSelectorUserActivity" to="/ScheduledTask/UserActivities" primaryText="User Activity" leftIcon={<HistoryIcon />} onClick={onMenuClick} /> : null}
				{isAdmin ? <MenuItemLink key="VIPCustomerList" to="/ScheduledTask/VIPCustomers" primaryText="VIP Customers" leftIcon={<StarBorderIcon />} onClick={onMenuClick} />: null}
			</List>
			: null}
			{isAdmin ?
			<List component="nav" subheader={<ListSubheader component="div">HEXSelector Licenses</ListSubheader>}>
				<MenuItemLink key="HEXSelectorSegmentList" to="/HEXSelector/SegmentCollections" primaryText="Licenses" leftIcon={<LockOpenIcon />} onClick={onMenuClick} />
				<MenuItemLink key="HEXSelectorSegments" to="/HEXSelector/Segments" primaryText="Segments" leftIcon={<AccountTreeIcon />} onClick={onMenuClick} ></MenuItemLink>
				<MenuItemLink key="HEXSelectorApplications" to="/HEXSelector/Applications" primaryText="Applications" leftIcon={<OpacityIcon />} onClick={onMenuClick} ></MenuItemLink>
				<MenuItemLink key="HEXSelectorProducts" to="/HEXSelector/Products" primaryText="Products" leftIcon={<ExtensionIcon />} onClick={onMenuClick} ></MenuItemLink>
				<MenuItemLink key="HEXSelectorOFConfigs" to="/HEXSelector/PandoraConfigs" primaryText="Pandora Application" leftIcon={<TrendingUpIcon />} onClick={onMenuClick} ></MenuItemLink>
				<MenuItemLink key="HEXSelectorPlatePandora" to="/HEXSelector/PlatePandora" primaryText="Pandora Moldel Factors" leftIcon={<AdjustIcon/>} onClick={onMenuClick} ></MenuItemLink>
			</List>
			: null }
			{isAdmin ? 
			<List component="nav" subheader={<ListSubheader component="div">HEXSelector AHRI</ListSubheader>}>
				<MenuItemLink key="HEXSelectorAHRI" to="/HEXSelector/ahri" primaryText="AHRI Versions" leftIcon={<GolfCourseIcon />} onClick={onMenuClick} />
			</List>
			: null}
			{isAdmin ?
			<List component="nav" subheader={<ListSubheader component="div">HEXSelector User Groups</ListSubheader>}>
				<MenuItemLink key="HEXSelectorPlateLists" to="/HEXSelector/PlateLists" primaryText="User Groups" leftIcon={<ListAltIcon />} onClick={onMenuClick} />
				<MenuItemLink key="HEXSelectorPlateTypeLists" to="/HEXSelector/PlateTypeLists" primaryText="Plate Type Lists" leftIcon={<ListAltIcon />} onClick={onMenuClick} />
				<MenuItemLink key="HEXSelectorPlateTypeNames" to="/HEXSelector/PlateTypeNames" primaryText="Plates" leftIcon={<ListAltIcon />} onClick={onMenuClick} />
			</List>
			: null}
			<Responsive
				small={logout}
				medium={null} // Pass null to render nothing on larger devices
			/>
		</div>)
};

const mapStateToProps = state => ({
		resources: getResources(state),
});

export default withRouter(connect(mapStateToProps)(MyMenu));